import React from 'react';
import intl from 'react-intl-universal';
import { MenuItem } from '@blueprintjs/core';
import { FMultiSelect } from '../Forms';

/**
 *
 * @param {*} query
 * @param {*} warehouse
 * @param {*} _index
 * @param {*} exactMatch
 * @returns
 */
const warehouseItemPredicate = (
  query: any,
  warehouse: any,
  _index: any,
  exactMatch: any,
) => {
  const normalizedTitle = warehouse.name.toLowerCase();
  const normalizedQuery = query.toLowerCase();

  if (exactMatch) {
    return normalizedTitle === normalizedQuery;
  } else {
    return (
      `${warehouse.code}. ${normalizedTitle}`.indexOf(normalizedQuery) >= 0
    );
  }
};

/**
 *
 * @param {*} branch
 * @param {*} param1
 * @returns
 */
const warehouseItemRenderer = (
  warehouse: any,
  { handleClick, modifiers, query }: any,
  { isSelected }: any,
) => {
  return (
    <MenuItem
      active={modifiers.active}
      disabled={modifiers.disabled}
      icon={isSelected ? 'tick' : 'blank'}
      text={warehouse.name}
      label={warehouse.code}
      key={warehouse.id}
      onClick={handleClick}
    />
  );
};

const warehouseSelectProps = {
  itemPredicate: warehouseItemPredicate,
  itemRenderer: warehouseItemRenderer,
  valueAccessor: (item: any) => item.id,
  labelAccessor: (item: any) => item.code,
  tagRenderer: (item: any) => item.name,
};

/**
 * warehouses mulit select.
 * @param {*} param0
 * @returns
 */
export function WarehouseMultiSelect({ warehouses, ...rest }: any) {
  return (
    <FMultiSelect
      items={warehouses}
      placeholder={intl.get('warehouses_multi_select.placeholder')}
      popoverProps={{ minimal: true, usePortal: false }}
      {...warehouseSelectProps}
      {...rest}
    />
  );
}
